module.exports = __webpack_public_path__ + "static/media/blob-sms.81d914a1.svg";